<template>
  <div class="main-layout">
    <el-container class="sidebar-holder">
      <el-container class="main-content">
        <the-header></the-header>
        <el-main>
          <router-view></router-view>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>
<script>
import TheHeader from '../components/TheHeader/TheHeader';

export default {
  components: { TheHeader },
  data() {
    return {
      
    };
  },
  methods: {
  },
};
</script>
<style lang="scss">
.main-layout {
  background-color: #f7f9fa;
  height: 100vh;
}
.sidebar-holder {
  height: 100%;
}
.sidebar {
  height: 100%;
}
.sidebar-menu {
  height: calc(100% - 60px);
}
.main-content {
  display: flex;
  flex-direction: column;
}
.navigation-link {
  text-decoration: none;
}
.navigation-item {
  display: flex;
  i {
    align-self: center;
    font-size: 25px!important;
    margin-right: 10px;
  }
}
.sidebar-header {
  height: 55px;
  display: flex;
  justify-content: space-around;
  background-color: #fff;
  padding: 0 20px 0 20px;
  .logo {
    width: 25px;
    align-self: center;
    cursor: pointer;
  }
}
</style>